function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14",
    focusable: "false",
    "aria-hidden": "true",
    stroke: "#4b5661",
    fill: "none",
    style: {
      display: "block",
      maxHeight: "100%",
      maxBlockSize: "100%",
      width: "100%",
      inlineSize: "100%",
      maxWidth: "100%",
      maxInlineSize: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.675 10.037 3.072 4.2h7.856l.397 5.837A2.4 2.4 0 0 1 8.932 12.6H5.069a2.4 2.4 0 0 1-2.394-2.563",
    style: {
      vectorEffect: "non-scaling-stroke",
      strokeWidth: "1.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9 3.5a2.1 2.1 0 1 1 4.2 0v1.4a2.1 2.1 0 0 1-4.2 0z",
    style: {
      vectorEffect: "non-scaling-stroke",
      strokeWidth: "1.4px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cartIcon.a3479f43a4be71846a2286c17904eb77.svg";
export { ForwardRef as ReactComponent };